// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xBaseTheme } from "@tps/XDL/types";

export default {
    popover: 1260,
    datePicker: 1270,
    dynamicDropdown: 1310,
    stickyFooter: 1284,
    loadingOverlay: 1285,
    drawer: 1290,
    modal: 1305,
    tabGroup: 400,
    toaster: 1600,
    shellPopover: 6000,
    // XNG-Changes
    menu: 1263,
    tippy: 1500,
    tooltip: 1306,
    header: 1284,
    compactHeader: 1264,
    scrimMenu: 1260,
    styledOverlay: 500,
} as xBaseTheme["zIndex"];
